module.exports = __webpack_public_path__ + "static/media/addon-gis.f1536178.webp";